import React, { Component } from 'react';
import UserContext from '../../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Button, Form, FormGroup, FormText, Input, Label, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { GoCheck, GoCircleSlash } from 'react-icons/go';
import moment from 'moment';
import { connect } from 'react-redux';

class CounPF extends Component {
    static displayName = CounPF.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            nameList: [],
            haveNames: false,
            termSelectOptions: ["Select..."],
            counselorName: "",
            clonefrom: [],
            cloneto: [{ "cloneto": "Select a source year or semester" }],
            bulkDeleteFrom: [],
            bulkDeleteModal: false,
            bulkDeleteSelect: "",
            currentSearch: [],
            defaultPFCode: "",
            addSuccess: null
        }
        this.getTermSelectOptions(); //this is necessary to handle the data.termname structure
        this.apiFetch("GetCloneOptionsPF", {}, "clonefrom")
        this.apiFetch("GetBulkDeleteTermsPF", {}, "bulkDeleteFrom")
    }    

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        this.setState({
            [stateItem]: data
        }, () => {
            if (url == "FindPFCounselors") {
                this.setState({
                    haveNames: true
                })
            }
        })
    }

    //writeUserData(input) {
    //    this.setState({
    //        returnable: input
    //    }, () => { this.testPermission() })
    //}

    //testPermission() {
    //    this.getTermSelectOptions();
    //    this.getCloneOptions();
    //    this.getBulkDeleteOptions();
    //}

    async getTermSelectOptions() {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetTermsForPFCounselors', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            termSelectOptions: data.termname
        })
    }

    //async getCloneOptions() {
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk
    //    }
    //    const response = await fetch('GetCloneOptionsPF', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    })
    //    const data = await response.json();
    //    this.setState({
    //        clonefrom: data
    //    })
    //}

    //async getBulkDeleteOptions() {
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk
    //    }
    //    const response = await fetch('GetBulkDeleteTermsPF', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    })
    //    const data = await response.json();
    //    this.setState({
    //        bulkDeleteFrom: data
    //    })
    //}

    //async getControlledCloneOptions(target) {
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
    //        selectedVal: target
    //    }
    //    const response = await fetch('GetControlledClonePF', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    })
    //    const data = await response.json();
    //    this.setState({
    //        cloneto: data
    //    })
    //}

    async findNamesPF(e) {
        e.preventDefault();
        const dataInput = new FormData(e.target);
        let toSend = {
            termselect: dataInput.getAll('term').join(',')
        }
        this.setState({
            currentSearch: toSend
        })
        this.apiFetch("FindPFCounselors", toSend, "nameList")
    }

    
    //async refreshSearch(toSend) {
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    const response = await fetch('FindPFCounselors', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    })
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        nameList: data,
    //        haveNames: true
    //    })
    //}

    async deleteCounselor(yearterm, fullname) {
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        let counPCID = fullname.substring(fullname.indexOf("(") + 1, fullname.length - 1)
        let toSend = {
            //userLevel: this.props.reduxData.userInfo.level.pk,
            insdel: "DEL",
            fromterm: yearterm,
            toterm: "",
            pfvalue: "",
            pcid: counPCID
        }
        //const response = await fetch('UpdateCounselorPF', {
        //    method: 'POST',
        //    headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
        //    body: JSON.stringify(toSend)
        //});
        //const data = await response.json();
        this.apiFetch("UpdateCounselorPF",toSend,"")
        //this.refreshSearch(this.state.currentSearch);
        this.apiFetch("FindPFCounselors", this.state.currentSearch, "nameList")
        this.apiFetch("GetBulkDeleteTermsPF", {}, "bulkDeleteFrom")
        //this.getBulkDeleteOptions();
    }

    bulkDelete(e) {
        this.setState({
            bulkDeleteSelect: e.target.value,
            bulkDeleteModal: true
        })
    }

    async bulkDeleteConfirm() {
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        let toSend = {
            //userLevel: this.props.reduxData.userInfo.level.pk,
            insdel: "DEL",
            fromterm: this.state.bulkDeleteSelect,
            toterm: "",
            pfvalue: "",
            pcid: ""
        }
        //const response = await fetch('UpdateCounselorPF', {
        //    method: 'POST',
        //    headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
        //    body: JSON.stringify(toSend)
        //});
        //const data = await response.json();
        //this.refreshSearch(this.state.currentSearch);
        this.apiFetch("UpdateCounselorPF",toSend,"")
        this.apiFetch("FindPFCounselors", this.state.currentSearch, "nameList")
        this.toggleConfirm();
        //this.getBulkDeleteOptions();
        this.apiFetch("GetBulkDeleteTermsPF", {}, "bulkDeleteFrom")
    }

    async nameLookup(e) {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if (e.target.value.length == 10) {
            let toSend = {
                stuPCID: e.target.value,
                userLevel: this.props.reduxData.userInfo.level.pk
            }
            this.getCounCode(e.target.value);
            const response = await fetch('stuLookupCounselor', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                counselorName: data.stuName
            });
        } else {
            this.setState({
                counselorName: "",
                defaultPFCode: ""
            })
        }
    }

    async getCounCode(pcid) {
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let counSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            counPCID: pcid
        }
        const response2 = await fetch('GetCounselorPFCode', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(counSend)
        });
        const data2 = await response2.json();
        this.setState({
            defaultPFCode: data2.counCode
        })
    }

    async addCounselor(e) {
        e.preventDefault();
        const dataInput = new FormData(e.target);
        let pfCodeVal = "";
        if ((dataInput.get('pfcode') == null || dataInput.get('pfcode') == "") && this.state.defaultPFCode != null) pfCodeVal = this.state.defaultPFCode;
        else if ((dataInput.get('pfcode') == null || dataInput.get('pfcode') == "") && this.state.defaultPFCode == null) pfCodeVal = "";
        else pfCodeVal = dataInput.get('pfcode');
        if (pfCodeVal.length == 3 && this.state.counselorName != "" && this.state.counselorName != "This PCID is not associated with anybody") {
            let toSend = {
                insdel: "INS",
                fromterm: "",
                toterm: dataInput.get('termadd'),
                pfvalue: pfCodeVal,
                pcid: dataInput.get('counpcid')
            }
            this.apiFetch("UpdateCounselorPF",toSend,"addSuccess")
            this.apiFetch("FindPFCounselors", this.state.currentSearch, "nameList")
            this.apiFetch("GetBulkDeleteTermsPF", {}, "bulkDeleteFrom")
        }
        else {
            this.setState({
                addSuccess: false
            })
        }
        setTimeout(() => {
            this.setState({
                addSuccess: null
            })
        }, 4000)
    }

    async cloneTo(e) {
        e.preventDefault();
        const dataInput = new FormData(e.target);
        let toSend = {
            insdel: "INS",
            fromterm: dataInput.get('clonefrom'),
            toterm: dataInput.get('cloneto'),
            pfvalue: "",
            pcid: ""
        }
        this.apiFetch("UpdateCounselorPF", toSend,"")
        this.apiFetch("FindPFCounselors", this.state.currentSearch, "nameList")
        this.apiFetch("GetBulkDeleteTermsPF", {}, "bulkDeleteFrom")
    }

    fullTableWithNames() {
        return (
            <div>
                <div className="inlineCustom">
                    <b>Add Counselor</b>
                    <Form inline className='d-flex' onSubmit={this.addCounselor.bind(this)}>
                        <FormGroup>
                            <Input type="select" name="termadd" id="termadd" bsSize="sm">
                                {this.state.termSelectOptions.map(term => (
                                    <option>{term}</option>
                                ))}
                            </Input>
                            <FormText></FormText>
                        </FormGroup>
                        &nbsp;
                        <FormGroup>
                            <Input type="text" name="counpcid" id="counpcid" onChange={this.nameLookup.bind(this)} placeholder="People Code ID" bsSize="sm" />
                            <FormText>{this.state.counselorName}</FormText>
                        </FormGroup>
                        &nbsp;
                        <FormGroup>                                                                                                                                                                                    {/* {this.state.defaultPFCode != null ? this.state.defaultPFCode : ""}*/}
                            <Input type="text" name="pfcode" id="pfcode" placeholder="PowerFAIDS Code" bsSize="sm" disabled={this.state.defaultPFCode != "" && this.state.defaultPFCode != null ? true : false} value={this.state.defaultPFCode} />
                            <FormText></FormText>
                        </FormGroup>
                        &emsp;
                        <Button outline color="success" submit>Add</Button>&nbsp;
                        {this.state.addSuccess && <GoCheck />}
                        {this.state.addSuccess == false && <GoCircleSlash color="#CC482B" />}
                    </Form>
                </div>
                &emsp;
                &emsp;
                &emsp;
                &nbsp;
                <div className="inlineCustom">
                    <b>Clone</b>
                    <Form inline className='d-flex' onSubmit={this.cloneTo.bind(this)}>
                        <Input type="select" name="clonefrom" id="clonefrom" defaultValue="DEFAULT" bsSize="sm" onChange={(e) => this.apiFetch("GetControlledClonePF",{selectedVal: e.target.value},"cloneTo")}>
                            <option disabled value="DEFAULT">Clone From...</option>
                            {this.state.clonefrom.map(from => (
                                <option>{from.clonefrom}</option>
                            ))}
                        </Input>
                        &nbsp;
                        <Input type="select" name="cloneto" id="cloneto" defaultValue="DEFAULT" bsSize="sm">
                            <option disabled value="DEFAULT">Clone To...</option>
                            {this.state.cloneto.map(to => (
                                <option disabled={to.cloneto == "Select a source year or semester" ? true : false}>{to.cloneto}</option>
                            ))}
                        </Input>
                        &emsp;
                        <Button outline color="success" submit>Clone</Button>
                    </Form>
                </div>
                <div className="rightAlignCustom">
                    <Input type="select" name="bulkDel" id="bulkDel" value="DEFAULT" onChange={this.bulkDelete.bind(this)}>
                        <option disabled value="DEFAULT">Delete All Term...</option>
                        {this.state.bulkDeleteFrom.map(select => (
                            <option value={select.yearterm}>{select.yearterm} ({select.count})</option>
                        ))}
                    </Input>
                </div>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>Year/Term</th>
                            <th>Counselor Code (PowerFAIDS)</th>
                            <th>Counselor Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.nameList.map(names => (
                            <tr>
                                <td>{names.yearterm}</td>
                                <td>{names.pfid}</td>
                                <td>{names.fullname}</td>
                                <td><Button outline color="danger" onClick={() => this.deleteCounselor(names.yearterm, names.fullname)}>Delete</Button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }

    toggleConfirm() {
        this.setState({
            bulkDeleteModal: !this.state.bulkDeleteModal
        })
    }

    render() {
        let nameTable = <div></div>
        if (this.state.haveNames == true) nameTable = this.fullTableWithNames();
        if (this.props.reduxData.userInfo == []) { return <div /> }
        return (
            <UserContext.Consumer>
                {contextData => (
                    <div>
                        <Modal isOpen={this.state.bulkDeleteModal} toggle={this.toggleConfirm.bind(this)}>
                            <ModalHeader toggle={this.toggleConfirm.bind(this)}>
                                Delete All From {this.state.bulkDeleteSelect}
                            </ModalHeader>
                            <ModalBody>
                                Are you sure you want to do this? This cannot be undone.
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={() => this.bulkDeleteConfirm()}>Yes</Button>&nbsp;<Button onClick={() => this.toggleConfirm()}>No</Button>
                            </ModalFooter>
                        </Modal>
                        <Form inline className='d-flex' onSubmit={this.findNamesPF.bind(this)} >
                            <FormGroup>
                                <Label>Term</Label>
                                <Input type="select" multiple name="term" id="term">
                                    {this.state.termSelectOptions.map(term => (
                                        <option>{term}</option>
                                    ))}
                                </Input>
                                <Button type="submit" outline color="success">Go</Button>
                            </FormGroup>
                        </Form>
                        <br />
                        {nameTable}
                    </div>
                )}
            </UserContext.Consumer>
        );

    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(CounPF);